import me from "models/me";
import siteConfig from "site-config";

export default function (nextState) {
    if (me.isSignedIn()) {
        window.location = `http://${siteConfig.legacyHost || window.location.host.replace("app.", "wholesale.")}${
            nextState.location.pathname
        }`;
    }
}
